import { Store } from '@ngrx/store';
import { Injectable } from '@angular/core';
import { IOption } from '../models/common/option';
import { IAppState } from '@core/state/app/app-state';
import { SetSessionLocaleAction } from '@core/state/session/session-actions';
/**
 * Manages language / translation related features.
 */
@Injectable()
export class LanguageService {

    constructor(private store$: Store<IAppState>) {
    }

    /**
     * Sets the application locale.
     * @param locale
     * @returns {any}
     */
    setLocale(locale: string): any {
        this.store$.dispatch(new SetSessionLocaleAction({ locale }));
    }

    getAllLocales(): IOption[] {
        return [
            {
                labelKey: 'Language.English',
                value: 'en-US',
                monthNameLength: 3
            },
            {
                labelKey: 'Language.Spanish',
                value: 'es-US',
                monthNameLength: 4
            },
            {
                labelKey: 'Language.French',
                value: 'fr-CA',
                monthNameLength: 4
            }
        ];
    }

}
